/**
 * @file paddle 客户案例
 * @author FengGuang(fengguang01@baidu.com)
 */

import React, {useCallback, useState} from 'react';
import {Button, Tabs} from 'antd';

import Header from '../../components/header/HeaderWithStore';
import Footer from '../../components/footer/footer';
import Banner from '../../components/banner/Banner';
import VideoTextCard from './components/video-text-card/VideoTextCard';
import VerticalTabText from './components/vertical-tab-text/VerticalTabText';

import useCustomerCaseHooks from './customerCaseHooks';
import UniversityList from './components/university-list/UniversityList';
import EnterpriseCaseList from './components/case-list/EnterpriseCaseList';
import DeveloperCaseList from './components/case-list/DeveloperCaseList';
import UniverseCaseList from './components/case-list/UniverseCaseList';
import RightNavigation from '../../components/right-navigation/RightNavigation';
import ReactStickyPolyfill from '../../components/react-sticky-polyfill/ReactStickyPolyfill';
import {getScrollTop} from '../../utils/get-scroll';


const IndexIndex: React.FC = () => {
    const {
        banner,
        enterpriseCase,
        enterpriseCaseIntroduce,
        enterpriseCaseCaseSelection,
        developerCase,
        developerCaseIntroduce,
        developerCaseCaseSelection,
        universityCases,
        universityCaseIntroduce,
        universityList,
        universityCaseCaseSelection
    } = useCustomerCaseHooks();

    const [tabSelectedKey, setTabSelectedKey] = useState<string>('1');

    const onTabSelectedKeyChange = useCallback((key: string) => {
        if (getScrollTop() > 274) {
            window.scrollTo({top: 274});
        }
        setTabSelectedKey(key);
    }, []);

    return (
        <div className="page paddle-cc-page">
            <Header />
            <Banner
                className="paddle-cc-page-banner"
                title={banner?.title}
                subtitle={banner?.subtitle}
            >
                {(banner?.btns.length ?? 0) > 0
                && (
                    <div className="paddle-hub-index-page-banner-btn-group">
                        {banner?.btns.map((btn) => (
                            <a
                                key={`${btn.title}${btn.href}`}
                                href={btn.href}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <Button
                                    type="primary"
                                    size="large"
                                    className="paddle-hub-index-page-banner-btn"
                                >
                                    {btn.title}
                                </Button>
                            </a>
                        ))}
                    </div>
                )}
            </Banner>
            <div>
                <ReactStickyPolyfill>
                    <div className="paddle-cc-page-tabs-title-wrap">
                        <div className="paddle-cc-content">
                            <Tabs
                                className="paddle-cc-page-tabs-title"
                                activeKey={tabSelectedKey}
                                onChange={onTabSelectedKeyChange}
                            >
                                <Tabs.TabPane
                                    key="1"
                                    tab={enterpriseCase?.title}
                                >
                                </Tabs.TabPane>
                                <Tabs.TabPane
                                    key="2"
                                    tab={developerCase?.title}
                                >
                                </Tabs.TabPane>
                                <Tabs.TabPane
                                    key="3"
                                    tab={universityCases?.title}
                                >
                                </Tabs.TabPane>
                            </Tabs>
                        </div>
                    </div>
                </ReactStickyPolyfill>
                <ReactStickyPolyfill>
                    <div className="paddle-cc-page-tabs-title-wrap-line" />
                </ReactStickyPolyfill>
                <ReactStickyPolyfill>
                    <div className="paddle-cc-page-tabs-title-wrap-line2" />
                </ReactStickyPolyfill>
                <div className="paddle-cc-content">
                    <Tabs
                        activeKey={tabSelectedKey}
                        renderTabBar={() => <React.Fragment />}
                    >
                        <Tabs.TabPane
                            tab={enterpriseCase?.title}
                            key="1"
                        >
                            {!!enterpriseCaseIntroduce
                            && (
                                <div className="paddle-cc-content-item">
                                    <div
                                        className="paddle-cc-content-h1"
                                    >
                                        {enterpriseCaseIntroduce.cardTitle}
                                    </div>
                                    <VideoTextCard
                                        {...enterpriseCaseIntroduce}
                                    />
                                </div>
                            )}
                            {!!enterpriseCaseCaseSelection
                            && (
                                <div className="paddle-cc-content-item">
                                    <div
                                        className="paddle-cc-content-h1"
                                    >
                                        {enterpriseCaseCaseSelection.title}
                                    </div>
                                    <VerticalTabText
                                        {...enterpriseCaseCaseSelection}
                                    />
                                </div>
                            )}
                        </Tabs.TabPane>
                        <Tabs.TabPane
                            tab={developerCase?.title}
                            key="2"
                        >
                            {!!developerCaseIntroduce
                            && (
                                <div className="paddle-cc-content-item">
                                    <div
                                        className="paddle-cc-content-h1"
                                    >
                                        {developerCaseIntroduce.cardTitle}
                                    </div>
                                    <VideoTextCard
                                        {...developerCaseIntroduce}
                                    />
                                </div>
                            )}
                            {!!developerCaseCaseSelection
                            && (
                                <div className="paddle-cc-content-item">
                                    <div
                                        className="paddle-cc-content-h1"
                                    >
                                        {developerCaseCaseSelection.title}
                                    </div>
                                    <VerticalTabText
                                        {...developerCaseCaseSelection}
                                    />
                                </div>
                            )}
                        </Tabs.TabPane>
                        <Tabs.TabPane
                            tab={universityCases?.title}
                            key="3"
                        >
                            {!!universityCaseIntroduce
                            && (
                                <div className="paddle-cc-content-item">
                                    <div
                                        className="paddle-cc-content-h1"
                                    >
                                        {universityCaseIntroduce.cardTitle}
                                    </div>
                                    <VideoTextCard
                                        {...universityCaseIntroduce}
                                    />
                                </div>
                            )}
                            {!!universityList
                            && (
                                <div className="paddle-cc-content-item">
                                    <div
                                        className="paddle-cc-content-h1"
                                    >
                                        {universityList.title}
                                    </div>
                                    <div
                                        className="paddle-cc-content-h3"
                                    >
                                        {universityList.subTitle}
                                    </div>
                                    <UniversityList
                                        {...universityList}
                                    />
                                </div>
                            )}
                            {!!universityCaseCaseSelection
                            && (
                                <div className="paddle-cc-content-item">
                                    <div
                                        className="paddle-cc-content-h1"
                                    >
                                        {universityCaseCaseSelection.title}
                                    </div>
                                    <VerticalTabText
                                        {...universityCaseCaseSelection}
                                    />
                                </div>
                            )}
                        </Tabs.TabPane>
                    </Tabs>
                </div>
                <div className="paddle-cc-page-grey">
                    <div className="paddle-cc-content-wide">
                        <Tabs
                            activeKey={tabSelectedKey}
                            renderTabBar={() => <React.Fragment />}
                        >
                            <Tabs.TabPane key="1">
                                <div className="paddle-cc-content">
                                    <div className="paddle-cc-content-item">
                                        <div
                                            className="paddle-cc-content-h1"
                                        >
                                            全部案例
                                        </div>
                                        <EnterpriseCaseList />
                                    </div>
                                </div>
                            </Tabs.TabPane>
                            <Tabs.TabPane key="2">
                                <div className="paddle-cc-content">
                                    <div className="paddle-cc-content-item">
                                        <div
                                            className="paddle-cc-content-h1"
                                        >
                                            全部案例
                                        </div>
                                        <DeveloperCaseList />
                                    </div>
                                </div>
                            </Tabs.TabPane>
                            <Tabs.TabPane key="3">
                                <div className="paddle-cc-content">
                                    <div className="paddle-cc-content-item">
                                        <div
                                            className="paddle-cc-content-h1"
                                        >
                                            全部案例
                                        </div>
                                        <UniverseCaseList />
                                    </div>
                                </div>
                            </Tabs.TabPane>
                        </Tabs>
                    </div>
                </div>
            </div>
            <RightNavigation />
            <Footer />
        </div>
    );
};

export default IndexIndex;
